export default "__VITE_ASSET__DzVySyhP__"